# ------------------------------------*|
# #Editor Layout -> Layout Drag && Drop
# ------------------------------------*|


moduleblocksBuilder = angular.module 'services.layoutEditor.blocksBuilder', [
  "services.editorNamespace"
]

moduleblocksBuilder.factory 'blocksBuilder', ["$timeout", "ns", "$injector", "Section", "Slider", "TimeMachine", "FrameForm", ($timeout, ns, $injector, Section, Slider, TimeMachine, FrameForm) ->

  Y = undefined

  blocksBuilder =
    resizers: null

    init: (y) ->
      Y = y
    destroy: ->
      @destroyResizers()
    isBlock: (el) ->
      if el and angular.isDefined(el.hasClass)
        el.hasClass(ns.blockClass.substr(1)) || el.hasClass(ns.blockDropOverlay.substr(1))
      else
        false
    isSection: (el) ->
      if angular.isDefined(el.hasClass)
        el.hasClass ns.sectionClass.substr 1
      else
        false
    isColumn: (el) ->
      if angular.isDefined(el.hasClass)
        el.hasClass ns.colClass.substr 1
      else
        false
    isRow: (el) ->
      if angular.isDefined(el.hasClass)
        el.hasClass ns.rowClass.substr 1
      else
        false
    getColSize: (element) ->
      if @isColumn(element) || @isBlock(element)
        colSize = parseInt (element.get('className').match(RegExp('(?:\\s|^)str-col-(\\d+?)(?:\\s|$)')) or ['',''])[1], 10
        if !isNaN(colSize) then colSize else false
      else
        false
    sumColumnsSize: (columns) ->
      parent = @
      numberColsSum = 0
      if angular.isDefined columns.each
        columns.each (col, i) ->
          colSize = parent.getColSize col
          numberColsSum += colSize
      numberColsSum
    updateColSize: (col, newval) ->
      if @isColumn(col) || @isBlock(col)
        col.removeClass "str-col-"+@getColSize(col)
        col.addClass "str-col-"+newval
      if @isBlock(col)
        col.widget.float_size = newval
    removeEmptySections: ->
      layoutEditor = $injector.get "layoutEditor"
      Y.all(ns.sectionClass).each (section, i) ->
        exists = Y.one(section).one(ns.rowClass)
        if !exists
          sectionId = section.section.id
          Section.remove sectionId
          section.remove()
          layoutEditor.cancelEditingLayout()
    removeEmptyRows: ->
      Y.all(ns.rowClass).each (row, i) ->
        exists = row.one(ns.colClass)
        row.remove() if !exists
    removeEmptyColumns: ->
      Y.all(ns.colClass).each (col, i) ->
        exists = Y.one(col).one(ns.blockClass)
        col.remove() if !exists
    removeUnnecessaryRows: ->
      layoutEditor = $injector.get "layoutEditor"
      layout = layoutEditor.layout
      layout.all(ns.rowClass).each (row) ->
        inheritCol = row.ancestor(ns.colClass)
        if inheritCol
          countCols = Y.one(row).all(ns.colClass).size()
          if countCols is 1
            widgets = Y.one(row).one(ns.colClass).all(ns.blockClass)
            row.insert widgets, "before"
      return
    createSection: (content, sectionType = "section") ->
      sectionType = "section" if sectionType is "default"
      clearFix = Y.Node.create("<div/>").addClass "clearfix"
      newSection = Y.Node.create('<'+sectionType+' class="'+ns.sectionClass.replace(".", "")+'"><div class="'+ns.wrapperClass.substr(1)+'">'+content+'</div></'+sectionType+'>')
      newSection.append clearFix
      newSection.section =
        section_type: sectionType
      newSection
    createRow: (content) ->
      clearFix = Y.Node.create("<div/>").addClass "clearfix"
      newRow = Y.Node.create('<div class="row '+ns.rowClass.replace(".", "")+'"></div>').setContent content
      newRow.append clearFix
      newRow
    createColumn: (size, content) ->
      size = content.widget and content.widget.min_size || 1
      Y.Node.create('<div class="'+ns.colClass.substr(1)+' str-col-' + size + '"></div>').setContent content
    createBlock: (content, type) ->
      Y.Node.create("<div class='#{ns.blockClass.substr(1)} str-bw_#{type}'><div class='widget-wrapper'>#{content}</div></div>")
    insertColumn: (direction, dragContent, dropTarget, widget) ->
      if dragContent.ancestor
        parentCol = dragContent.ancestor(ns.colClass)
        if parentCol
          size = @getColSize(parentCol)
        else
          size = widget.min_size
      newColumn = @createColumn size, dragContent
      colTarget = dropTarget.ancestor(ns.colClass)
      insertDirection = if direction is "right" then "after" else "before"
      colTarget.insert newColumn, insertDirection
    insertRow: (direction, dragContent, dropTarget) ->
      targetParentRow = dropTarget.ancestor(ns.rowClass) || dropTarget
      newRow = @createRow @createColumn(ns.maxColumns, dragContent)
      insertDirection = if direction is "bottom" then "after" else "before"
      targetParentRow.insert newRow, insertDirection
    insertRowIntoColumn: (direction, dragContent, dropTarget) ->
      colWithDragContent = @createColumn(ns.maxColumns, dragContent)
      newRow = @createRow colWithDragContent
      insertDirection = if direction is "left" then "after" else "before"
      dropTarget.insert newRow, "after"
      colWithDragContent.insert @createColumn(ns.maxColumns, dropTarget), insertDirection
    insertBlock: (direction, dragNode, targetNode) ->
      if targetNode.float
        parentCol = targetNode.ancestor ns.colClass
        size = Math.floor 6
        dragNode.addClass "#{ns.floatingClass}-#{targetNode.float} str-col-#{size}"
      else
        blockDragDrop = $injector.get "blockDragDrop"
        if blockDragDrop.dragNode
          blockDragDrop.removeFloating()
      insertDirection = if direction is "bottom" then "after" else "before"
      targetNode.insert dragNode, insertDirection
    initResizers: ->
      parent = @
      layoutEditor = $injector.get "layoutEditor"
      @destroyResizers()
      layoutEditor.layout.all(ns.colClass).each (col) ->
        parent.insertIfLastCol col
      @resizers = new (Y.DD.Delegate)(
        container: ns.tplContainer
        nodes: ".#{ns.helperClass}"
        invalid: ".#{ns.floatingClass}-left .#{ns.helperClass}, .#{ns.floatingClass}-right .#{ns.helperClass}"
        dragConfig:
          groups: Y.all(".#{ns.resizerClass}")
          move: false)
      @resizers.on "drag:mouseDown", @_onResizerDDMousedown, @
      @resizers.on "drag:start", @_onResizerDragStart, @
      @resizers.on "drag:drag", @_onResizerDragDrag, @
      @resizers.on "drag:end", @_onResizerDragEnd, @
      @initFloatResizers()
    sizeAloneFloatingBlocks: (col) ->
      self = @
      blocks = col.all ns.blockClass
      blockDragDrop = $injector.get "blockDragDrop"
      floatingBlocks = 0
      blocks.each (block) ->
        if self.isFloating(block)
          floatingBlocks++
      if blocks.size() is floatingBlocks
        blocks.each (block) ->
          blockDragDrop.removeFloating block
    setupSizeColumnsInRow: (row, dragNode) ->
      insertedCol = dragNode.ancestor ns.colClass if dragNode
      maxCols = ns.maxColumns
      parent = @
      columns = Y.one(row).all("> #{ns.colClass}")
      sumColSize = parent.sumColumnsSize(columns)
      columns.each (col, i) ->
        parent.sizeAloneFloatingBlocks col
        colSize = parent.getColSize col
        if dragNode and columns.size() > 1
          if col._yuid isnt insertedCol._yuid
            if sumColSize < maxCols
              parent.updateColSize col, colSize+1
              sumColSize++
            if sumColSize > maxCols and colSize > parent.getMinColSize(col)
              parent.updateColSize col, colSize-1
              sumColSize--
        else
          if sumColSize < maxCols
            parent.updateColSize col, colSize+1
            sumColSize++
          if sumColSize > maxCols and colSize > parent.getMinColSize(col)
            parent.updateColSize col, colSize-1
            sumColSize--
      if (sumColSize isnt 0) and (sumColSize < maxCols) || (sumColSize > maxCols)
        @setupSizeColumnsInRow row, dragNode
    setupSizeColumns: (row, dragNode = false) ->
      layoutEditor = $injector.get "layoutEditor"
      layout = layoutEditor.layout
      parent = @
      layout.all(ns.rowClass).each (row) -> parent.setupSizeColumnsInRow row, dragNode
    _onResizerDragStart: (e) ->
      targetNode = e.target.get('node')
      posX = e.target.nodeXY[0]
      sizeG = 12
      Y.one('html').addClass 'str-resizing-col'
      @targetNode = targetNode
      @leftCol = targetNode.ancestor ns.colClass
      @rightCol = @leftCol.next()
      @leftOriginalSize = @getColSize @leftCol
      @rightOriginalSize = @getColSize @rightCol
      @oldSizes = [@leftOriginalSize, @rightOriginalSize]
      @originalResizerPos = @xToCol(posX + sizeG)
      @leftCol.addClass 'str-resizing str-resizing-left'
      @rightCol.addClass 'str-resizing str-resizing-right'
    _onResizerDragDrag: (e) ->
      currentResizePoint = undefined
      mouseX = e.target.mouseXY[0]
      diff = @gridSteps[1] - @gridSteps[0]
      k = 0
      stopsCount = @gridSteps.length
      while k < stopsCount
        currentResizePoint = @gridSteps[k]
        if mouseX < @gridSteps[0] - diff
          newColSizeLeft = @getMinColSize(@leftCol)
          newColSizeRight = @rightOriginalSize + @leftOriginalSize - newColSizeLeft
          @updateColSize(@leftCol, newColSizeLeft)
          @updateColSize(@rightCol, newColSizeRight)
        else if mouseX > @gridSteps[@gridSteps.length - 1] + diff
          newColSizeRight = @getMinColSize(@rightCol)
          newColSizeLeft = @leftOriginalSize + @rightOriginalSize - newColSizeRight
          @updateColSize(@leftCol, newColSizeLeft)
          @updateColSize(@rightCol, newColSizeRight)
        else if mouseX > currentResizePoint - (diff / 2) and mouseX < currentResizePoint + diff / 2
          newColSizeRight = k - @originalResizerPos
          newColSizeLeft = @leftOriginalSize + newColSizeRight
          newColSizeRight = @rightOriginalSize - newColSizeRight
          minLeftSize = @getMinColSize(@leftCol)
          minRightSize = @getMinColSize(@rightCol)
          maxLeftSize = @getMaxColSize(@leftCol)
          maxRightSize = @getMaxColSize(@rightCol)
          if newColSizeLeft < minLeftSize or newColSizeLeft > maxLeftSize or newColSizeRight < minRightSize or newColSizeRight > maxRightSize
            break
          if newColSizeLeft is @getColSize(@leftCol)
            break
          newColSizeLeft = Math.min(Math.max(1, newColSizeLeft), ns.maxColumns)
          newColSizeRight = Math.min(Math.max(1, newColSizeRight), ns.maxColumns)
          @updateColSize @leftCol, newColSizeLeft
          @updateColSize @rightCol, newColSizeRight
          break
        k++
      Slider.updateSliders()
      FrameForm.updateFrameForms()
      return
    colResizeCapture: ->
      newSizes = [@getColSize(@leftCol), @getColSize(@rightCol)]
      widget = @targetNode.ancestor(ns.colClass).one(ns.blockClass).widget
      TimeMachine.capture "resizeCol", {widgetId: widget.id, oldSizes: @oldSizes, newSizes: newSizes}
    _onResizerDragEnd: ->
      layoutEditor = $injector.get "layoutEditor"
      allCols = Y.all ns.colClass
      allCols.removeClass "str-resizing-left"
      allCols.removeClass "str-resizing-right"
      allCols.removeClass "str-resizing"
      @colResizeCapture()
      Y.one('html').removeClass 'str-resizing-col'
      layoutEditor.save()
    getAvailableColSize: (row, dragCol, fromDragOver = false, clone = false) ->
      self = @
      size = 0
      row.all("> #{ns.colClass}:not(.str-col-from)").each (col) ->
        size += self.getMinColSize(col)
      if dragCol and dragCol.ancestor(ns.rowClass) is row and !clone
        if dragCol.all("> #{ns.blockClass}").size() > 1+fromDragOver
          size += @getMinColSize(dragCol)
      if dragCol and dragCol.ancestor(ns.colClass) and dragCol.ancestor(ns.colClass).ancestor(ns.colClass)
        return @getColSize(dragCol.ancestor(ns.colClass).ancestor(ns.colClass))-size
      else
        return ns.maxColumns-size
    getMinColSize: (col) ->
      sizes = []
      col.all(ns.blockClass).each (block) ->
        if block.widget and block.widget.min_size
          sizes.push Math.max(block.widget.min_size)
      return Math.max.apply Math, sizes
    getMaxColSize: ->
      ns.maxColumns
    xToCol: (origResizerPos) ->
      diff = (@gridSteps[1] - @gridSteps[0]) / 2
      if origResizerPos < @gridSteps[0]
        return 0
      if origResizerPos > @gridSteps[@gridSteps.length]
        return ns.maxColumns - 1
      i = 0
      while i < @gridSteps.length
        stopVal = @gridSteps[i]
        if origResizerPos > stopVal - diff and origResizerPos < stopVal + diff
          return i
        i++
      return
    _onResizerDDMousedown: (e) ->
      col = e.target.get('node').ancestor ns.colClass, true
      @calcColResizeStops col
    calcColResizeStops: (col) ->
      section = col.ancestor ns.rowClass
      widthSection = parseInt(section.getStyle('width'), 10)
      paddingLeftSection = parseInt(section.getStyle("paddingLeft"), 10)
      # colSize = if col then @getColSize(col) else ns.maxColumns
      colSize = 1
      ratio = widthSection / ns.maxColumns
      posXsection = section.getXY()[0]
      @gridSteps = []
      while colSize < ns.maxColumns - 1
        @gridSteps.push posXsection + paddingLeftSection + Math.round(ratio * (colSize + 1))
        colSize++
    destroyResizers: ->
      if @resizers and @resizers isnt null
        @resizers.destroy()
      if @floatResizers and @floatResizers isnt null
        @floatResizers.destroy()
      layoutEditor = $injector.get "layoutEditor"
      if layoutEditor.layout
        layoutEditor.layout.all(".#{ns.helperClass}").remove()
    insertIfLastCol: (element) ->
      lastColIndex = element.ancestor(ns.rowClass).all("> #{ns.colClass}").size()-1
      thisIndex = $(element._node).index()
      lastInRow = thisIndex is lastColIndex
      if @getColSize(element) < ns.maxColumns && !lastInRow
        @appendResizerTo element
    appendResizerTo: (element) ->
      element.appendChild "<div class='#{ns.helperClass}'><div class='#{ns.resizerClass}'><div class='#{ns.resizerLineClass}'></div></div></div>"
    _onFloatResizerDragStart: (e) ->
      parentCol = e.target.get("node").ancestor ns.colClass
      @currentWidth = @getColSize e.target.get("node").ancestor ns.blockClass
      @minWidth = 1
      @maxWidth = 12
      @floatGridsteps = parseInt(parentCol.get("region").width / @maxWidth, 10)
    _onFloatResizerDragDrag: (e) ->
      block = e.target.get('node').ancestor ns.blockClass
      newSize = Math.floor((e.target.mouseXY[0] - (e.target.startXY[0])) / @floatGridsteps)
      if @isFloatRight(block)
        newSize *= -1
      newSize += @currentWidth
      if newSize > 0 && newSize < 13
        @updateColSize block, newSize
    _onFloatResizerDragEnd: (e) ->
      blockDragDrop = $injector.get "blockDragDrop"
      block = e.target.get('node').ancestor ns.blockClass
      blockSize = @getColSize block
      if blockSize is ns.maxColumns
        blockDragDrop.removeFloating block
    isFloatRight: (block) ->
      block.hasClass ns.floatingClass+"-right"
    isFloating: (block) ->
      if block
        block.hasClass(ns.floatingClass+"-right") || block.hasClass(ns.floatingClass+"-left")
    initFloatResizers: ->
      parent = @
      layoutEditor = $injector.get "layoutEditor"
      layoutEditor.layout.all(".#{ns.floatingClass}-left").each (block) ->
        parent.appendResizerTo block
      layoutEditor.layout.all(".#{ns.floatingClass}-right").each (block) ->
        parent.appendResizerTo block
      @floatResizers = new (Y.DD.Delegate)(
        container: ns.tplContainer
        nodes: ".#{ns.floatingClass}-left .#{ns.helperClass}, .#{ns.floatingClass}-right .#{ns.helperClass}"
        invalid: ".#{ns.colClass} .#{ns.helperClass}"
        dragConfig:
          move: false)
      @floatResizers.on "drag:start", @_onFloatResizerDragStart, @
      @floatResizers.on "drag:drag", @_onFloatResizerDragDrag, @
      @floatResizers.on "drag:end", @_onFloatResizerDragEnd, @
  blocksBuilder
]



// WEBPACK FOOTER //
// ./src/app/editor/services/layout_editor/blocksBuilder.coffee